import * as types from '../mutaion-types';

export default {
	namespaced: true,

	state: {
		volumes: 0,
		articles: 0,
		series: 0,
		visits: 0,
	},

	actions: {
		fetchVolumes({ commit }) {
			return axios.get('/volumes/count').then((response) => {
				commit(types.STORE_STATISTICS_VOLUMES, response.data);
				return response.data;
			});
		},
		fetchArticles({ commit }) {
			return axios.get('/articles/count').then((response) => {
				commit(types.STORE_STATISTICS_ARTICLES, response.data);
				return response.data;
			});
		},
		fetchSeries({ commit }) {
			return axios.get('/series/count').then((response) => {
				commit(types.STORE_STATISTICS_SERIES, response.data);
				return response.data;
			});
		},
		fetchVisits({ commit }) {
			return axios.get('/visits').then((response) => {
				commit(types.STORE_STATISTICS_VISITS, response.data);
				return response.data;
			});
		},
		addVisit() {
			return axios.post('/visits').then((response) => {
				return response.data;
			});
		},
	},

	mutations: {
		[types.STORE_STATISTICS_VOLUMES](state, volumes) {
			state.volumes = volumes;
		},

		[types.STORE_STATISTICS_ARTICLES](state, articles) {
			state.articles = articles;
		},

		[types.STORE_STATISTICS_SERIES](state, series) {
			state.series = series;
		},

		[types.STORE_STATISTICS_VISITS](state, visits) {
			state.visits = visits;
		},
	},

	getters: {},
};
